import { render, staticRenderFns } from "./InstanceEditCatalog.vue?vue&type=template&id=558f887e&scoped=true&"
import script from "./InstanceEditCatalog.vue?vue&type=script&lang=js&"
export * from "./InstanceEditCatalog.vue?vue&type=script&lang=js&"
import style0 from "./InstanceEditCatalog.vue?vue&type=style&index=0&id=558f887e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f887e",
  null
  
)

export default component.exports